var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTruck(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40.275,
    height: 23.484,
    viewBox: "0 0 40.275 23.484",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .prefix__a,\n            .prefix__b {\n                fill: none;\n                stroke:currentColor;\n                stroke-linecap: round;\n                stroke-miterlimit: 10;\n                stroke-width: 1.3px\n            }\n\n            .prefix__a {\n                stroke-linejoin: round\n            }\n        "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(.65 .65)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "prefix__a",
    d: "M32.643 19.276h4.5l1.829-6.472-3.377-1.688-3.1-8.02h-7.317l.844-3.1H4.643"
  }), /*#__PURE__*/React.createElement("path", {
    className: "prefix__b",
    d: "M13.359 19.276h12.678"
  }), /*#__PURE__*/React.createElement("path", {
    className: "prefix__a",
    d: "M1.266 12.522l-.844 3.377h3.236l-.844 3.377h3.94"
  }), /*#__PURE__*/React.createElement("path", {
    className: "prefix__b",
    d: "M1.342 3.39h10.74M0 9.431h10.068M3.356 6.746h12.082"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "prefix__a",
    cx: 3.356,
    cy: 3.02,
    rx: 3.356,
    ry: 3.02,
    transform: "translate(6.712 16.143)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "prefix__a",
    cx: 3.02,
    cy: 3.02,
    r: 3.02,
    transform: "translate(26.178 16.143)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "prefix__b",
    d: "M25.186 3.096l-4.312 16.181"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTruck);
export default __webpack_public_path__ + "static/media/truck.a9417a19c57c38e86b63ded3de901d70.svg";
export { ForwardRef as ReactComponent };